import React from "react";
import { Separator as BaseSeparator } from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./Separator.module.scss";

export const Separator = (
    props: React.ComponentProps<typeof BaseSeparator>,
) => (
    <BaseSeparator
        {...props}
        className={concatClassNames([props.className, styles.root])}
        elementType="div"
    />
);
